var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76.17 91.46"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "user_svg__cls-1",
    d: "M37.87 91.44H16.44c-4 0-7.78-.78-11.06-3.42A14 14 0 01.05 77C-.23 69.28.56 61.72 4 54.59c2.86-6 7.44-9.49 14.1-10.32 2.31-.29 4.05.62 5.92 1.63a58.88 58.88 0 009.1 4.45C38.1 52 43 51 47.67 48.62a26.38 26.38 0 004.17-2.54c3.33-2.64 6.85-2.07 10.43-.84a16.46 16.46 0 019.26 8.19c4.25 8 5.3 16.72 4.28 25.56-.89 7.76-7.12 12.36-15.9 12.44-7.35.07-14.7.01-22.04.01z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "user_svg__cls-1",
    d: "M59.4 22.13a22 22 0 11-43.94-.21 22 22 0 1143.94.21z"
  })));
}
export default SvgUser;